<template>  
  <div class="dass-step-info-container">
    <div class="align-left flex column">
        <dass-button 
          :class="this.isSafari ? `dass-button-secondary-${this.brandName}` : ''"
          class="q-mb-lg q-mt-lg"
          style="max-width: 100px;"
          @click="() => $router.back()"
          type="button" 
          variant="secondary">
           <q-icon name="mdi-arrow-left" size="16px" class="q-mr-xs" />
            {{ $t('dass.goBack') }}
        </dass-button>
        <span>{{$t('dass.statusCurrent')}}:</span>
        <b><h3>{{ getStatusLabel }}</h3></b>
        
        <div class="dass-step-container">
            <StatusOrderStep :statusPed="getStatus" />
        </div>
        <q-list  separator>
            <q-item>
                <q-item-section>{{ $t('dass.addressOfDelivery') }}:</q-item-section>
                <q-item-section>{{ address }}</q-item-section>
            </q-item>

            <q-item>
                <q-item-section>{{ $t('dass.carrier') }}:</q-item-section>
                <q-item-section>{{ carrier }}</q-item-section>
            </q-item>

            <q-item>
                <q-item-section>{{ $t('dass.estimatedDelivery') }}:</q-item-section>
                <q-item-section>{{ estimate }}</q-item-section>
            </q-item>

            <q-item>
                <q-item-section>{{ $t('dass.deliveredOn') }}:</q-item-section>
                <q-item-section>{{ deliveredAt }}</q-item-section>
            </q-item>
        </q-list>
    </div>
    <div class="flex q-gutter-md q-mt-md dass-container-button">
        <dass-button 
          :disabled="!imageOrder"
          :class="this.isSafari ? `dass-button-secondary-${this.brandName}` : ''"                        
          @click="showModalPhotoOrder = true"
          type="button" 
          class="dass-button-order-tracking"
          variant="secondary">            
          {{ $t('dass.photoOfOrder') }}            
        </dass-button>
        <dass-link             
          :id="`dass-link-order-${this.brandName}`"                
          @click="openNewPageCarrier"
          class="dass-button-order-tracking"
        >
            <span style="text-align: center;">{{ $t('dass.trackOnTheCarrier') }}</span>
        </dass-link>        
    </div>
  </div>
  <ModalViewImg
    v-if="showModalPhotoOrder"
    :imgSrc="imageOrder"
    :showModal="showModalPhotoOrder"
    :isIframeGoogleDrive="true"
    sizeModal="large"
    @closeModal="showModalPhotoOrder = false"
  />
</template>
<script>
import StatusOrderStep from './StatusOrderStep.vue';
import { useIsSafari } from '@/composables/useIsSafari'
import { mapActions } from 'vuex'
import ModalViewImg from '../../molecules/ModalViewImg.vue';
import {StatusOrderStepList}  from '@/helpers/constants/StatusOrder'

export default {
  name: 'StatusStepInfo',
  setup() {
    const { isSafari, brandName } = useIsSafari()          
    return {
      isSafari,
      brandName
    }
  },
  props: {
    statusPed: String,
    address: String,
    carrier: String,
    estimate: String,
    deliveredAt: String,
    urlCarrier: String,
    order: Object,
    isPublic: {
      type: Boolean,
      default: false
    }
  },
  components: {
    StatusOrderStep,
    ModalViewImg
  },
  data() {
    return {
      showModalPhotoOrder: false,
      imageOrder: ''
    };
  },  
  computed: {
    getStatusLabel() {      
      return StatusOrderStepList.find(s => s.key == this.getStatus?.toUpperCase())?.label
    },
    getStatus() {      
      return this.statusPed 
    }
  },
  methods: {
    ...mapActions('orders', ['getPhotographCollection']),
    ...mapActions('toasts', {
      showToast: 'showToast',
    }), 
    openNewPageCarrier() {
      this.urlCarrier ? window.open(this.urlCarrier, '_blank') : this.$ShowAlert({variant: 'warning', message: this.$t('dass.urlCarrierIndisponible')})      
    },
    async loadImageOrder() { 
      if (this.isPublic) {
        this.imageOrder = this.order?.ID_IMAGEDRIVE || '';
        return; 
      }           
      if(!this.order?.PED_EMPRESA || !this.order?.PED_FILIAL || !this.order?.FAT_SEQUENCIA) {
        this.imageOrder = '';
        return;
      }
     const response =  await this.getPhotographCollection({
           emp_codigo: this.order.PED_EMPRESA,
           fil_codigo: this.order.PED_FILIAL,
           fat_sequencia: this.order.FAT_SEQUENCIA          
        }).catch((err) => {
          this.showToast({
            variant: 'warning',
            message: err?.message || err
          })         
        })        
      this.imageOrder = response?.length ? response[0]?.ID_IMAGEDRIVE : ''
      
    }
  },
  watch: {
    order: {
      handler() {
        this.loadImageOrder()
      },
      deep: true,
      immediate: true
    }        
  }  
};
</script>
<style scoped>
.dass-step-info-container {
  width: 100%;

}
#dass-link-order-newbalance {
    text-transform: uppercase; 
    background-color: #E5788B !important;
    transition: background-color 0.3s ease !important;  
    padding: var(--space__0-5x); 
    border-radius: var(--theme-border-radius);
    &:hover {
      color: var(--theme-white) !important;
    }
  }
  #dass-link-order-fila {
    text-transform: uppercase; 
    background-color: #758396 !important;
    padding: var(--space__0-5x); 
    &:hover {
      color: var(--theme-white) !important;
    } 
  }
  #dass-link-order-umbro {
    text-transform: uppercase; 
    color: var(--theme-color) !important;
    padding: var(--space__0-5x);  
    background-color: #737373; 
    transition: background-color 0.3s ease !important;
    &:hover {
      background-color: #f0e7e79d !important;
    }
  }
  .dass-step-container {
    width: 100%;    
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
  }
  .dass-step-container::-webkit-scrollbar {
    height: 8px;
  }
  .dass-step-container::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 5px;
  }
  .dass-button-order-tracking {
      flex: 1;
      align-items: center;
      justify-content: center;
      height: 40px;
  }
  .dass-container-button {
    @media (max-width: 768px) {
      flex-direction: column;
    }

  }
</style>